@import "@/scss/use-bootstrap-mixins.scss";

.alert {
  font-size: 14px !important;
  padding: 12px 12px;
  border-radius: 4px;
  display: block;
  margin: 12px 0;
  font-weight: 500 !important;
  display: flex;
  gap: 12px;

  svg {
    max-width: 20px;
  }
}

.alert_error {
  background-color: #faeded;
  color: #d04d52 !important;
  border: 1px solid #d04d52;
}

.alert_success {
  background-color: #e7f9f1;
  color: #25bd59 !important;
  border: 1px solid #25bd59;
}

.alert_warning {
  background-color: #fff8e3;
  color: #cb9700 !important;
  border: 1px solid #cb9700;
}

.alert_info {
  background-color: #ebf1f8;
  color: #457cbf !important;
  border: 1px solid #457cbf;
}

.fitContent {
  width: fit-content;
  margin: 0 auto;
}
